import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const heatmapCommonOptions = {
  credits: false,
  chart: {
    type: "heatmap",
    height: 500,
    marginTop: 100,
    spacingTop: 20,
    plotBorderWidth: 0,
  },
  title: {
    text: null,
  },
  xAxis: {
    tickWidth: 0,
    lineWidth: 0,
    gridLineWidth: 0,
    minorGridLineWidth: 0,
    labels: {
      style: {
        color: withVar(DesignToken.ContentBasicSecondary),
      },
    },
  },
  yAxis: {
    categories: [
      "11:00 PM",
      "10:00 PM",
      "9:00 PM",
      "8:00 PM",
      "7:00 PM",
      "6:00 PM",
      "5:00 PM",
      "4:00 PM",
      "3:00 PM",
      "2:00 PM",
      "1:00 PM",
      "12:00 PM",
      "11:00 AM",
      "10:00 AM",
      "9:00 AM",
      "8:00 AM",
      "7:00 AM",
      "6:00 AM",
      "5:00 AM",
      "4:00 AM",
      "3:00 AM",
      "2:00 AM",
      "1:00 AM",
      "12:00 AM",
    ],
    title: null,
    tickWidth: 0,
    lineWidth: 0,
    gridLineWidth: 0,
    minorGridLineWidth: 0,
    labels: {
      style: {
        color: withVar(DesignToken.ContentBasicSecondary),
      },
    },
  },
  colorAxis: {
    min: 1,
    minColor: withVar(DesignToken.DecorBlue100),
    maxColor: withVar(DesignToken.DecorBlue500),
    allowDecimals: false,
    tickPixelInterval: 60,
    labels: {
      // FIXME: Fix this the next time the file is edited.
      // @ts-expect-error TS(7023): 'formatter' implicitly has return type 'any' becau... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      formatter() {
        // @ts-expect-error TS(2339): Property 'isFirst' does not exist on type '{ forma... Remove this comment to see the full error message
        if (this.isFirst) {
          return 1;
        }
        // @ts-expect-error TS(2339): Property 'value' does not exist on type '{ formatt... Remove this comment to see the full error message
        if (this.value >= 1000 && this.value < 1000000) {
          // @ts-expect-error TS(2339): Property 'value' does not exist on type '{ formatt... Remove this comment to see the full error message
          return `${this.value / 1000}k`;
        }
        // @ts-expect-error TS(2339): Property 'value' does not exist on type '{ formatt... Remove this comment to see the full error message
        if (this.value >= 1000000) {
          // @ts-expect-error TS(2339): Property 'value' does not exist on type '{ formatt... Remove this comment to see the full error message
          return `${this.value / 1000000}M`;
        }
        // @ts-expect-error TS(2339): Property 'value' does not exist on type '{ formatt... Remove this comment to see the full error message
        return this.value;
      },
      style: {
        color: withVar(DesignToken.ContentBasicSecondary),
      },
    },
  },
  tooltip: {
    padding: 0,
    borderWidth: 0,
    borderRadius: "10",
    backgroundColor: withVar(DesignToken.SurfacePrimaryDefault),
    useHTML: true,
    shadow: true,
  },
  legend: {
    y: -30,
    margin: 0,
    align: "right",
    layout: "horizontal",
    verticalAlign: "top",
    symbolWidth: 250,
    padding: 20,
  },
  series: [
    {
      color: withVar(DesignToken.ContentInvertPrimary),
      borderColor: withVar(DesignToken.SurfacePrimaryDefault),
      borderWidth: 4,
      states: {
        hover: {
          brightness: 0.1,
        },
      },
    },
  ],
};
